import { useState, useEffect, useRef, useContext } from "react";
import { Row, Col, Form } from "react-bootstrap";
import axios from "axios";
import DataTable from "./Data";
import "../components/Timer.css";
import "../components/button.css";
import Cookies from "js-cookie";
import { API_URL } from "../App";
import { marginBottom } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import "dayjs/locale/pl";
import { pl } from "date-fns/locale";
import { TextField } from "@mui/material";
import { format } from "date-fns";
import Alerts from "../components/Alerts";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import { SearchContext } from "../components/SearchContext";

const VoiceInput = () => {
  const { userData } = useContext(UserDataContext);
  const [value, setValue] = useState("");
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchMode, setSearchMode] = useState(false);
  const [urlPath, setUrlPath] = useState(API_URL + "/list/aktualne");
  const [data, setData] = useState([]);
  const duration = 10000;
  const [remainingTime, setRemainingTime] = useState(duration);
  const [timerRunning, setTimerRunning] = useState(false);
  const sessionId = Cookies.get("alzheimer");
  const [text, setText] = useState("Pobieranie danych...");
  const [error, setError] = useState(null);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [all, setAll] = useState("Wszystkie");
  const today = new Date();
  const defaultDate = new Date(today.setMonth(today.getMonth() + 1));
  const itemsPerPage = 10;
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const { searchValue, setSearchValue } = useContext(SearchContext);
  const [update, setUpdate] = useState(0);

  const handleEditTask = (task) => {
    setValue(task.content);
    setUpdate(task.update);
    console.log("Task: ", task);
    try {
      const date = new Date(task.date);
      if (!isNaN(date)) {
        setSelectedDate(date);
      } else {
        console.error("Nieprawidłowy format daty:", task.date);
      }
    } catch (error) {
      console.error("Błąd podczas konwersji daty:", error);
    }
  };

  const handleDateChange = (newDate) => {
    if (newDate === null || isNaN(newDate)) {
      setSelectedDate(null);
    } else {
      setSelectedDate(newDate);
    }
  };
  const [selectedDate, setSelectedDate] = useState(defaultDate);
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = false;
      recognitionRef.current.interimResults = false;
      recognitionRef.current.lang = "pl-PL";
      recognitionRef.current.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setValue((prevValue) => prevValue + " " + transcript);
        setListening(true);
        console.log("hello");
      };
      recognitionRef.current.onerror = (event) => {
        console.error("Error occurred in recognition: ", event.error);
        setListening(false);
      };
    } else {
      console.warn("Web Speech API is not supported in this browser.");
    }
  }, []);

  const handleVoiceInput = () => {
    if (listening) {
      recognitionRef.current.stop();
      setListening(false);
      setTimerRunning(false);
      setRemainingTime(duration);
    } else {
      recognitionRef.current.start();
      setListening(true);
      setTimerRunning(true);
      console.log("listening");
      setTimeout(() => {
        recognitionRef.current.stop();
        setListening(false);
        setTimerRunning(false);
        setRemainingTime(duration);
      }, duration);
    }
  };

  const url = API_URL + `/insert/${sessionId}`;
  const handleClear = () => {
    setValue("");
    setSelectedDate(null);
    setSearchValue("");
    setUpdate(0);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("value", value);
    const formattedDate = format(selectedDate, "yyyy-MM-dd");

    formData.append("datetask", formattedDate);

    //for (const pair of formData.entries()) {
    //  console.log(`${pair[0]}: ${pair[1]}`);
    //}

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.error === 200) {
        setApiResponse({
          title: "Informacja",
          severity: "info",
          info: "Dopisano nowe zadanie",
        });
        setShowApiResponse(true);
      }
      if (response.data.error === 556) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Brak informacji do zarejestrowania",
        });
        setShowApiResponse(true);
      }
      setRefreshKey((oldKey) => oldKey + 1);
      console.log("resp:", response.data);
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Prawdopodobnie zostało utracone połączenie z serwerem.",
      });

      setShowApiResponse(true);
    }

    setValue("");
  };
  useEffect(() => {
    if (listening) {
      setApiResponse({
        title: "Nagrywanie tekstu",
        severity: "warning",
        info: "Trwa nagrywanie tekstu",
      });
      setShowApiResponse(true);
    } else {
      setShowApiResponse(false);
    }
  }, [listening]);

  useEffect(() => {
    if (timerRunning) {
      const interval = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1000);
        console.log(remainingTime);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [timerRunning]);

  let progress = 100 - (remainingTime / duration) * 100;
  useEffect(() => {
    const fetchData = async () => {
      const url = `${urlPath}/${sessionId}`;

      try {
        if (searchMode) {
          const response = await axios.post(
            url,
            { param: value },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          setData(response.data);

          if (response.data.length === 0) setText("Brak danych...");
        } else {
          const response = await axios.get(url);
          setData(response.data);
          //console.log(response.data);
          if (response.data.length === 0) setText("Brak danych...");
        }
      } catch (error) {
        setError(error.message);
      }
    };

    if (userData && userData.userId && searchValue === "") {
      //console.log("Search mode: ", searchMode, searchValue);
      if (searchValue === "") fetchData();
      const intervalId = setInterval(fetchData, 1000);
      return () => clearInterval(intervalId);
    }
  }, [
    refreshKey,
    searchMode,
    value,
    urlPath,
    userData,
    sessionId,
    searchValue,
  ]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handlePrint = () => {
    const printContent = document.getElementById("printable-table").innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  const handleUpdate = (id) => {
    setData((prevData) => prevData.filter((item) => item.id !== id));
  };

  const handleShow = (e) => {
    if (e.target.name === "Wszystkie") {
      setAll("Aktualne");
    }
    if (e.target.name === "Aktualne") {
      setAll("Wszystkie");
    }
    if (all === "Aktualne") {
      handleClear();
      setUrlPath(API_URL + "/list/aktualne");
      setAll("Wszystkie");
    } else if (all === "Wszystkie") {
      handleClear();
      setUrlPath(API_URL + "/list/wszystkie");
      setAll("Aktualne");
    }
    setSearchMode(false);
  };
  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };

  const search = async (searchValue) => {
    const url = API_URL + `/search/${sessionId}`;
    try {
      const response = await axios.post(
        url,
        { param: searchValue },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setData(Array.isArray(response.data) ? response.data : []);
      if (response.data.length === 0) setText("Brak danych...");
    } catch (error) {
      setError(error.message);
    }
  };

  if (searchValue !== "") {
    search(searchValue);
  }
  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  //  const paginatedData = data.slice(startIdx, endIdx);
  const paginatedData = Array.isArray(data) ? data.slice(startIdx, endIdx) : [];

  return (
    <div className="bodyReminder">
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h5>Lista do przypomnienia.</h5>
      <h6>
        Rejestracja zdarzeń z przyszłości. Widoczne dane z najbliższego
        miesiąca.
      </h6>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl}>
        <Row>
          <Col md={1}>
            {value.length > 0 && (
              <Button
                variant="contained"
                className="w-100"
                onClick={handleSubmit}
              >
                Zapisz
              </Button>
            )}
          </Col>
          <Col md={7}>
            <Form.Group controlId="description">
              <Form>
                <Form.Group className="mb-3" controlId="insert.ControlTextarea">
                  <TextField
                    label="W celu nagrywania lub wpisania kliknij w to pole."
                    multiline
                    rows={2}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onClick={handleVoiceInput}
                    fullWidth
                  />
                </Form.Group>
              </Form>
            </Form.Group>
          </Col>
          <Col>
            <DatePicker
              label="Data realizacji"
              value={selectedDate}
              onChange={handleDateChange}
              format="yyyy-MM-dd"
              slotProps={{ textField: { variant: "outlined" } }}
            />
          </Col>
          <Col>
            {value.length > 0 && (
              <Button
                variant="contained"
                className="w-100"
                onClick={handleClear}
              >
                Wyczyść
              </Button>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="mb-3">
            <div className="timer-container">
              <div
                className="timer-bar"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12} sm={6} md={3} className="mb-2">
            <Button
              variant="contained"
              className="w-100"
              onClick={(e) => handleShow(e)}
            >
              {all}
            </Button>
          </Col>
          <Col xs={12} sm={6} md={3} className="mb-2">
            <Button variant="contained" className="w-100" onClick={handlePrint}>
              Drukuj
            </Button>
          </Col>
        </Row>
      </LocalizationProvider>
      <Row style={{ marginBottom }}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </Row>
      <div id="printable-table">
        {data.length > 0 && userData.userId ? (
          <DataTable
            data={paginatedData}
            buttonAll={all}
            onUpdate={handleUpdate}
            onEdit={handleEditTask}
          />
        ) : (
          <div>
            <h6>{text}</h6>
          </div>
        )}
      </div>

      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={handleChangePage}
        color="primary"
        variant="outlined"
        shape="rounded"
      />
    </div>
  );
};

export default VoiceInput;
